import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { useTableActions } from '../../../../components/tables/MultiSelectTableContext'
import { segmentsClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation RemoveSegments($ids: [Int]) {
    removeSegments(ids: $ids)
  }
`

export const useRemoveSegments = () => {
  const notify = useNotification()
  const modal = useAlert()
  const { clearSelection } = useTableActions()
  const { t } = useTranslation('common')

  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Segments', 'SegmentsCount'],
    client: segmentsClient
  })

  const handleRequest = ids => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false

    return request({ variables: { ids } }).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: t('errorDelete') })
      }
      if (!resp.errors) {
        if (clearSelection) clearSelection()
      }
    })
  }

  return [handleRequest, state]
}
